import { render, staticRenderFns } from "./OrderTeacher.vue?vue&type=template&id=e060d7ac&scoped=true&"
import script from "./OrderTeacher.vue?vue&type=script&lang=js&"
export * from "./OrderTeacher.vue?vue&type=script&lang=js&"
import style0 from "./OrderTeacher.vue?vue&type=style&index=0&id=e060d7ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e060d7ac",
  null
  
)

export default component.exports